import { IBoundedContext } from '../../config';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import 'rxjs/add/observable/throw';
import { ApiService, StoreHelper, ConfigService } from '../../shared/services';
import { Product, ProductFamily, InventoryLocation } from '../shared';

@Injectable()
export class InventoryDetailService {
  products: Array<Product> = [];
  product: Product = <Product>{};

  private _inventory: IBoundedContext;

  constructor(
                private _storeHelper: StoreHelper,
                private _apiService: ApiService,
                private _configService: ConfigService ) {
                     this._inventory = this._configService.getContext('inventory');
                }

  getProductById(productId: number): Observable<Product> {
      return this._apiService.get(this._inventory.url, `products/${ productId }`)
                .map((response: ProductFamily) => this._setProduct(response, productId))
                .cache();
  }

  private _setProduct(productFromServer: ProductFamily, productId: number): Product {
      this.product.name = productFromServer.name;
      this.product.id = productId;
      this.product.locations = [];

      let childProduct = <Product>productFromServer.products.find( x => x.id === productId );
      let current = 0;
      let maximum = 0;

      childProduct.inventory.locations.map((location: InventoryLocation) => {

          if (location.isAtLocation) {

                current += location.current;
                maximum += location.maximum;

                let inventoryLocation = new InventoryLocation(location);
                inventoryLocation.updateMissQty(location.current);
                this.product.locations.push(inventoryLocation);
          }
      });

      this.product.current = current;
      this.product.missQuantity = current - maximum;
      this.products.push(this.product);
      this._storeHelper.update('products', this.products);

      return this.product;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/inventory-detail/inventory-detail.service.ts